import { GoogleReCaptchaProvider } from "@google-recaptcha/react"

import "../entrypoints/application.css"

import { Header } from "./components/header"
import { InsiderAccessSection } from "./components/insider-access-section"
import { JoinTheConversationSection } from "./components/join-the-conversation-section"
import { GetYourFansSection } from "./components/get-your-fans-section"
import { Footer } from "./components/footer"
import { useThemeColor } from "~/hooks/use-theme-color"
import { SCREENS } from "~/common/analytics"
import { useScreenTracking } from "~/hooks/use-screen-tracking"
import { getMetaContentMaybe } from "~/common/get-meta-content"

const recaptchaSiteKey = getMetaContentMaybe<string>("RECAPTCHA_SITE_KEY")

export const LandingScreen = () => {
  useThemeColor("#F6F6F1")
  useScreenTracking(SCREENS.Landing)
  return (
    <GoogleReCaptchaProvider
      siteKey={recaptchaSiteKey || ""}
      type="v3"
      explicit={{ badge: "hidden" }}
    >
      <section className="w-full" data-testid="landing-screen">
        <Header />
        <InsiderAccessSection />
        <JoinTheConversationSection />
        <GetYourFansSection />
        <Footer />
      </section>
    </GoogleReCaptchaProvider>
  )
}
